import { ISoilAnalysis } from "../../omnia"
import { validateSsmValue } from "../../ssm/attrs"
import { EditorAttribute } from "./types"

/**
 * Validates all the attributes of an analysis. Results are set on the "error" property of each attribute.
 */
export function validateAnalysis(analysis: ISoilAnalysis, attrs: EditorAttribute[]) {
    attrs.forEach(a => a.error = validateSsmValue(a, analysis[a.property]))
}

/**
 * Gets updated comments
 * @param attrs Editor attributes
 */
export function getUpdatedComments(analysis: ISoilAnalysis, attrs: EditorAttribute[]) {

    return attrs
        .filter(a => {
            const c = a.comment
            if (!c) return false
            if (c.useDefault) return false
            const d = a.getClass(analysis[a.property])
            return ((c.text || "") != (d?.DefaultComment || ""))
        })
        .map(c => ({
            PropertyName: c.property,
            Comment: c.comment.text?.trim()
        }
        ))

}
